module.exports = {"TXTWCL_Leave_Club":{"id":"TXTWCL_Leave_Club","defaultMessage":"クラブを去る","track":"Leave Club"}}